<template>
  <ontos-dialog :model-value="true" :fullscreen="$vuetify.display.smAndDown" max-width="1400px"
            @update:model-value="onDialogInput">
    <v-card>
      <ontos-view-class :idea-alias-prop="ideaAlias" :workspace="workspace"
                        @showMessage="$emit('showMessage', $event)"
                        @showErrorMessage="$emit('showErrorMessage', $event)">
        <template #controls>
          <ontos-dialog-actions :full-page-route="fullPageRoute" @closed="$emit('closed')"/>
        </template>
      </ontos-view-class>
    </v-card>
  </ontos-dialog>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import ViewClass from '@/components/design/class/ViewClass.vue'
import {EnhancedWorkpace} from '@/types/Workspace'

/**
 * O design da coleção sem sair de onde se está. Casca de modal sobre a mesma tela
 * da rota, como ViewInstanceDialog e KanbanDialog fazem com as suas.
 *
 * Os modais que o ViewClass abre — propriedade e fluxo — ficam DENTRO desta árvore,
 * que é como o Vuetify descobre os aninhados: fora dela, disputariam o foco com este.
 */
@Component({emits: ['closed'], 
  name: 'ontos-view-class-dialog',
  components: {'ontos-view-class': ViewClass}
})
class ViewClassDialog extends Vue {
  @Prop({type: String, required: true}) readonly ideaAlias!: string
  @Prop({required: true}) readonly workspace!: EnhancedWorkpace

  get fullPageRoute() {
    return {name: 'view-idea', params: {...this.$route.params, idea: this.ideaAlias}}
  }

  onDialogInput(open: boolean) {
    if (!open) this.$emit('closed')
  }
}

export default toNative(ViewClassDialog)
</script>
